import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        type="date"
        ref={ref}
        className={cn(
          "w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100",
          "focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent",
          "[&::-webkit-calendar-picker-indicator]:dark:invert [&::-webkit-calendar-picker-indicator]:dark:brightness-100",
          "[&::-webkit-calendar-picker-indicator]:hover:cursor-pointer",
          "[&::-webkit-calendar-picker-indicator]:dark:hover:opacity-80",
          "[&::-webkit-calendar-picker-indicator]:p-0",
          className
        )}
        {...props}
      />
    );
  }
);

DateInput.displayName = 'DateInput';

export { DateInput };